import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { returnDateInterimPurchaseHistoryText } from '../../../utils/order-history/card-utils';
import { FeatureSwitches } from '../../../constants/feature-switches';
var InterimReturnDate = function (_a) {
    var fg = _a.fg, _b = _a.bold, bold = _b === void 0 ? true : _b;
    return (React.createElement("div", null,
        React.createElement(Typography, { variant: "body-base", weight: "".concat(bold ? 'bold' : 'regular') }, returnDateInterimPurchaseHistoryText(fg, Boolean(FeatureSwitches.enableReturnProgressDate)))));
};
export default InterimReturnDate;
